const initSlider = () => {
	const blocks = document.querySelectorAll(
		'.wp-block-deoblocks-testimonials-slider'
	);

	if ( blocks.length < 0 ) return;

	blocks.forEach( ( currentBlock ) => {
		const swiperOptions = currentBlock.getAttribute( 'data-swiper' );

		if ( swiperOptions ) {
			const parsedSwiperOptions = JSON.parse( swiperOptions );
			const swiperPagination =
				currentBlock.querySelector( '.swiper-pagination' );

			const swiperBackButton = currentBlock.querySelector(
				'.swiper-button-prev'
			);
			const swiperNextButton = currentBlock.querySelector(
				'.swiper-button-next'
			);

			const swiperConfig = {
				loop: false,
				autoplay: {
					delay: 5000,
				},
				spaceBetween: parsedSwiperOptions.spaceBetween ?? 30,
				breakpoints: {
					560: {
						slidesPerView: 1,
					},
				},
				modules: [],
			};

			if ( parsedSwiperOptions.slidesPerView ) {
				swiperConfig.breakpoints = {
					560: {
						slidesPerView: 1,
					},
					782: {
						slidesPerView: parsedSwiperOptions.slidesPerView,
					},
				};
			}

			if ( parsedSwiperOptions.autoplay === true ) {
				swiperConfig.modules.push( SwiperAutoplay );
				swiperConfig.autoplay = {
					delay: 5000,
				};
			}

			if ( parsedSwiperOptions.loop === true ) {
				swiperConfig.loop = parsedSwiperOptions.loop;
			}

			if ( parsedSwiperOptions.pagination ) {
				swiperConfig.modules.push( SwiperPagination );
				swiperConfig.pagination = {
					el: swiperPagination,
					clickable: true,
				};
			}

			if ( parsedSwiperOptions.navigation ) {
				swiperConfig.modules.push( SwiperNavigation );
				swiperConfig.navigation = {
					nextEl: swiperNextButton,
					prevEl: swiperBackButton,
				};

				if ( parsedSwiperOptions.arrowsPositionOffset ) {
					// Adjust slider container margin and padding
					const offsetValue = Math.abs(
						parsedSwiperOptions.arrowsPositionOffset
					);
					currentBlock.style.marginTop = `-${ offsetValue }px`;
					currentBlock.style.paddingTop = `${ offsetValue }px`;
				}
			}

			let swiper = new Swiper( currentBlock, swiperConfig );
		}
	} );
};

document.addEventListener( 'DOMContentLoaded', () => {
	initSlider();
} );
